import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './app'
import { Toaster } from './components/ui/sonner'
import './index.css'
import { trpc, trpcClient } from './trpc/client'

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 30_000,
			retry: 1,
		},
	},
})

ReactDOM.createRoot(document.getElementById('root')!).render(
	<React.StrictMode>
		<trpc.Provider client={trpcClient} queryClient={queryClient}>
			<QueryClientProvider client={queryClient}>
				<BrowserRouter>
					<App />
					<Toaster position="top-right" richColors closeButton />
				</BrowserRouter>
			</QueryClientProvider>
		</trpc.Provider>
	</React.StrictMode>,
)
